import React from 'react'

import PageLayout from 'containers/PageLayout'
import DashboardContainer from 'containers/Dashboard'
import withAuth from 'hoc/withAuth'

const Index = () => (
  <PageLayout>
    <DashboardContainer />
  </PageLayout>
)

export default withAuth(Index)
